import { Injectable, inject } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import { type ExternalEventNames } from '../types/external-event-names';
import { ExternalEventPrefix } from './../enums/external-event-prefix.enum';

/** This service is used for event communication with external sources e.g. with the native application */
@Injectable({
    providedIn: 'root',
})
export class ExternalEventService {
    private readonly windowRef = inject<Window>(WA_WINDOW);

    public dispatch<T>(eventName: ExternalEventNames, payload: T, prefix: ExternalEventPrefix = ExternalEventPrefix.Form): void {
        const customEvent = new CustomEvent<T>(`${prefix}.${eventName}`, {
            detail: payload,
        });

        this.windowRef.dispatchEvent(customEvent);
    }

    public registerEventListener<T>(
        eventName: ExternalEventNames,
        listener: (evt: CustomEvent<T>) => void,
        prefix: ExternalEventPrefix = ExternalEventPrefix.Form,
    ): void {
        this.windowRef.addEventListener(`${prefix}.${eventName}`, listener as (evt: Event) => void);
    }
}
